import * as z from "zod";
import { zql } from "../generatedDrizzleSchema";
import { mutator } from "./mutator";

export const setNetworkEnforcedSchema = z.object({
  networkId: z.string(),
  enforced: z.boolean(),
});

// Enforcement is tenant routing policy, so network:write isn't enough to flip it.
export const setNetworkEnforced = mutator({
  schema: setNetworkEnforcedSchema,
  resolve: {
    network: { kind: "network", from: "networkId" },
  },
  permissions: [
    {
      permission: "tenant:networks_manage",
      scopeId: ({ ctx }) => ctx.tenantId,
    },
  ],
  fn: async ({ tx, args: { network, enforced } }) => {
    await tx.mutate.networks.update({ id: network.id, enforced });
    const routes = await tx.run(
      zql.egressRoutes.where("networkId", network.id)
    );
    for (const route of routes) {
      await tx.mutate.egressRoutes.update({ id: route.id, enforced });
    }
  },
});
